export const EMAIL_CUSTOMER_SUPPORT = 'aip@corrprocanada.com';
export const EMAIL_AV_PRIMARY_DEV = 'aip@corrprocanada.com';
